import api_client from '@/repositories';
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';

export interface IUseListResourcesQueryArgs
	extends UseQueryOptions<Awaited<ReturnType<typeof api_client.rootPages.list>>> {}

export function useListRootPagesQuery(args?: IUseListResourcesQueryArgs) {
	return useQuery({
		queryKey: ['root-pages', 'list'],
		queryFn: api_client.rootPages.list,
		...args,
	});
}

export interface IUseGetRootPageQueryArgs
	extends UseQueryOptions<Awaited<ReturnType<typeof api_client.rootPages.details>>> {
	id: string;
}

export function useGetRootPageQuery(args: IUseGetRootPageQueryArgs) {
	return useQuery({
		queryKey: ['root-pages', 'details', args.id],
		queryFn: () => api_client.rootPages.details({ id: args.id }),
		...args,
	});
}

export interface IUseGetPublicRootPageQuery
	extends UseQueryOptions<Awaited<ReturnType<typeof api_client.rootPages.publicDetails>>> {
	slug: string;
}

export function useGetPublicRootPageQuery(args: IUseGetPublicRootPageQuery) {
	return useQuery({
		queryKey: ['root-pages', 'public-details', args.slug],
		queryFn: () => api_client.rootPages.publicDetails({ slug: args.slug }),
		...args,
	});
}

export function useUpdateOrCreateRootPageMutation() {
	const client = useQueryClient();

	return useMutation({
		mutationFn: api_client.rootPages.updateOrCreate,
		onSuccess() {
			client.invalidateQueries(['root-pages']);
		},
	});
}

export function useRemoveRootPageMutation() {
	const client = useQueryClient();

	return useMutation({
		mutationFn: api_client.rootPages.remove,
		onSuccess() {
			client.invalidateQueries(['root-pages']);
		},
	});
}
